import React, { memo } from 'react'
import PropTypes from 'prop-types'

const Audio = ({ src, type = 'url', ...props }) => {
  switch (type) {
    case 'url':
      break
    case 'blob':
      if (src) {
        src = window.URL.createObjectURL(src)
      }
      break
    default:
      break
  }
  return <audio className="calls__recordings-audio" controls controlsList="nodownload" src={src || null} {...props} />
}

Audio.propTypes = {
  type: PropTypes.oneOf(['url', 'blob']),
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

export default memo(Audio)
